import type { SourceWarning } from '../model';
import type { GeoJsonInspection } from './geojsonInspection';

export function warningsForInspection(
  inspection: GeoJsonInspection,
  additionalWarnings: readonly SourceWarning[] = [],
): readonly SourceWarning[] {
  if (inspection.geometry.renderableFeatureCount > 0) return additionalWarnings;

  return [
    {
      code: 'no-renderable-geometry',
      message: 'This file contains no renderable geometry, so the current map view was kept.',
    },
    ...additionalWarnings,
  ];
}
